//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param statusId (optional)
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param sortColumn (optional)
   * @param sortAscending (optional)
   * @param fullTextFilter (optional)
   * @param impersonated_User (optional)
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getAllNotification(
    v: string,
    statusId?: number | undefined,
    pageIndex?: number | undefined,
    pageSize?: number | undefined,
    sortColumn?: string | null | undefined,
    sortAscending?: boolean | undefined,
    fullTextFilter?: string | null | undefined,
    impersonated_User?: any | undefined,
    hOSTNAME?: any | undefined
  ): Promise<NotificationResponse> {
    let url_ = this.baseUrl + "/api/notification/v{v}/notification?";
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v));
    if (statusId === null)
      throw new Error("The parameter 'statusId' cannot be null.");
    else if (statusId !== undefined)
      url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
    if (pageIndex === null)
      throw new Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
      url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (sortColumn !== undefined && sortColumn !== null)
      url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
    if (sortAscending === null)
      throw new Error("The parameter 'sortAscending' cannot be null.");
    else if (sortAscending !== undefined)
      url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
    if (fullTextFilter !== undefined && fullTextFilter !== null)
      url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Impersonated_User:
          impersonated_User !== undefined && impersonated_User !== null
            ? "" + impersonated_User
            : "",
        HOSTNAME:
          hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAllNotification(_response);
    });
  }

  protected processGetAllNotification(
    response: Response
  ): Promise<NotificationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as NotificationResponse);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          "If Authorization header not present, has no value or no valid jwt bearer token",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "If user not authorized to perform requested action",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<NotificationResponse>(null as any);
  }

  /**
   * @param impersonated_User (optional)
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional)
   * @return Success
   */
  updateNotification(
    v: string,
    impersonated_User?: any | undefined,
    hOSTNAME?: any | undefined,
    body?: NotificationTemplateModel | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/notification/v{v}/notification";
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        Impersonated_User:
          impersonated_User !== undefined && impersonated_User !== null
            ? "" + impersonated_User
            : "",
        HOSTNAME:
          hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        "Content-Type": "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateNotification(_response);
    });
  }

  protected processUpdateNotification(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          "If Authorization header not present, has no value or no valid jwt bearer token",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "If user not authorized to perform requested action",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional)
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getNotificationById(
    id: number,
    v: string,
    impersonated_User?: any | undefined,
    hOSTNAME?: any | undefined
  ): Promise<NotificationTemplateModel> {
    let url_ = this.baseUrl + "/api/notification/v{v}/notification/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Impersonated_User:
          impersonated_User !== undefined && impersonated_User !== null
            ? "" + impersonated_User
            : "",
        HOSTNAME:
          hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetNotificationById(_response);
    });
  }

  protected processGetNotificationById(
    response: Response
  ): Promise<NotificationTemplateModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as NotificationTemplateModel);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        let result404: any = null;
        result404 =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "Not Found",
          status,
          _responseText,
          _headers,
          result404
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          "If Authorization header not present, has no value or no valid jwt bearer token",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "If user not authorized to perform requested action",
          status,
          _responseText,
          _headers
        );
      });
    } else {
      return response.text().then((_responseText) => {
        let resultdefault: any = null;
        resultdefault =
          _responseText === ""
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProblemDetails);
        return throwException(
          "Error",
          status,
          _responseText,
          _headers,
          resultdefault
        );
      });
    }
  }

  /**
   * @param toAddress (optional)
   * @param id (optional)
   * @param impersonated_User (optional)
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  sendTestEmail(
    v: string,
    toAddress?: string | null | undefined,
    id?: number | undefined,
    impersonated_User?: any | undefined,
    hOSTNAME?: any | undefined
  ): Promise<boolean> {
    let url_ =
      this.baseUrl + "/api/notification/v{v}/notification/sendtestemail?";
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v));
    if (toAddress !== undefined && toAddress !== null)
      url_ += "toAddress=" + encodeURIComponent("" + toAddress) + "&";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Impersonated_User:
          impersonated_User !== undefined && impersonated_User !== null
            ? "" + impersonated_User
            : "",
        HOSTNAME:
          hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendTestEmail(_response);
    });
  }

  protected processSendTestEmail(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          "If Authorization header not present, has no value or no valid jwt bearer token",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "If user not authorized to perform requested action",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @param impersonated_User (optional)
   * @param hOSTNAME (optional) localhost:3000
   * @param body (optional)
   * @return Success
   */
  updateNotificationStatus(
    v: string,
    impersonated_User?: any | undefined,
    hOSTNAME?: any | undefined,
    body?: NotificationStatus | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/notification/v{v}/notification/updatenotificationstatus";
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        Impersonated_User:
          impersonated_User !== undefined && impersonated_User !== null
            ? "" + impersonated_User
            : "",
        HOSTNAME:
          hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        "Content-Type": "application/json",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateNotificationStatus(_response);
    });
  }

  protected processUpdateNotificationStatus(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          "If Authorization header not present, has no value or no valid jwt bearer token",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "If user not authorized to perform requested action",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param impersonated_User (optional)
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
  getNotificationStatus(
    v: string,
    impersonated_User?: any | undefined,
    hOSTNAME?: any | undefined
  ): Promise<number> {
    let url_ =
      this.baseUrl +
      "/api/notification/v{v}/notification/getnotificationstatus";
    if (v === undefined || v === null)
      throw new Error("The parameter 'v' must be defined.");
    url_ = url_.replace("{v}", encodeURIComponent("" + v));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Impersonated_User:
          impersonated_User !== undefined && impersonated_User !== null
            ? "" + impersonated_User
            : "",
        HOSTNAME:
          hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
        Accept: "text/plain",
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetNotificationStatus(_response);
    });
  }

  protected processGetNotificationStatus(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200;
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          "If Authorization header not present, has no value or no valid jwt bearer token",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          "If user not authorized to perform requested action",
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<number>(null as any);
  }
}

export interface NotificationListModel {
  id?: number;
  name?: string | undefined;
  subject?: string | undefined;
  bodyContent?: string | undefined;
  userProperties?: string | undefined;
  module?: string | undefined;
  active?: boolean;
  notificationTypeId?: number;
}

export interface NotificationResponse {
  recordCount?: number;
  emailAllRecords?: NotificationListModel[] | undefined;
  data?: NotificationListModel[] | undefined;
}

export interface NotificationTemplateModel {
  id?: number;
  name?: string | undefined;
  subject?: string | undefined;
  bodyContent?: string | undefined;
  userProperties?: string | undefined;
  module?: string | undefined;
  active?: boolean;
}

export interface ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export interface NotificationStatus {
  id?: number;
  status?: boolean;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
